import $ from 'jquery';
import _ from 'lodash';

export default function animateFaze($timeout) {
    return {
        restrict: 'A',
        link: function(scope, iElement, iAttrs) {
            let element = $('#faze-for-day');
            let row = $('.content');
            const cssClasses = [];

            row.children().each((i, c) => {
                cssClasses.push($(c).attr('class'));
            });

            function restoreCssClasses() {
                row.children().each((i, c) => {
                    $(c).attr('class', cssClasses[i]);
                });
            }

            function zoomOut() {
                row
                    .children()
                    .addClass('animated-panel')
                    .removeClass('zoomIn')
                    .addClass('zoomOut');
            }

            function zoomIn() {
                row
                    .children()
                    .addClass('animated-panel')
                    .removeClass('zoomOut')
                    .addClass('zoomIn');
            }

            scope.$watch('vm.days.length', (newVal, oldVal) => {
                if (oldVal !== newVal) {
                    if (newVal > 1) {
                        zoomOut();
                        $timeout(() => {
                            element.siblings().addClass('hide');
                            element.attr('class', 'col-lg-12');
                            zoomIn();
                        }, 400);
                    } else {
                        restoreCssClasses();
                        zoomOut();
                        $timeout(() => {
                            restoreCssClasses();
                            element.siblings().removeClass('hide');
                            element.attr('class', 'col-lg-6');
                            zoomIn();
                        }, 400);
                    }
                    $timeout(() => {
                        restoreCssClasses();
                    }, 1000);
                }
            });
        }
    };
}

animateFaze.$inject = ['$timeout'];



// WEBPACK FOOTER //
// ./app/components/dashboard/animateFaze.directive.js